import { createFileRoute } from '@tanstack/react-router';
import { loadCatalogText } from '../../i18n/catalogText';
import { PlaygroundTab } from '../../pages/dashboard/playground/PlaygroundTab';

// The playground shows catalog data text (descriptions, addon labels, input
// field descriptions), so the locale's translation memory loads before it renders.
export const Route = createFileRoute('/dashboard/playground')({
  loader: () => loadCatalogText(),
  component: PlaygroundTab,
});
